<template>
  <div id="navigation" class="inline space-between" :class="$mq">
    <div v-for="(item, index) in steps" :key="index" class="step-wrapper inline center">
      <router-link :to="{ path: item, query: $route.query }" class="step" :class="[status(index), {TA:isTestAchat}]">
        <SvgIcon :icon="`step-${item}`" class="icon" stroke fill />
      </router-link>
      <!-- <div class="separator" v-if="index < steps.length - 1"></div> -->
    </div>
    <div class="separator" :class="{TA:isTestAchat}">
      <span :style="{ width: progression }"></span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      // steps: ["energy", "consumption", "calculation", "contact"]
    };
  },
  computed: {
    ...mapGetters("podium", ["isForcedProduct"]),
    ...mapGetters("common", ["isTestAchat"]),
    progression() {
      let count = this.steps.indexOf((this.$route.name || "energy").toLowerCase())
      let percentage = (100 / (this.steps.length - 1)) * count;
      if(count < 0) percentage = 100;

      return `${percentage}%`;
    },
    noSubscribe() {
      return this.$router.currentRoute.query.noSubscribe !== undefined || this.$store.state.common.noSubscribe;
    },
    steps() {
      let steps = ["energy", "calculation", "consumption", "contact"];

      if(this.noSubscribe) {
        steps = ["energy", "calculation", "consumption"]
      } else if(this.$store.state.common.customerRef !== undefined && this.$store.state.common.customerRef != null) {
        steps = ["energy", "calculation", "consumption"]
      }


      if(this.isForcedProduct) {
        steps.shift();
      }

      return steps;
    }
  },
  methods: {
    status(index) {
      let status = "";

      if (this.$route.name) {
        if (
          index < this.steps.indexOf(this.$route.name.toLowerCase()) ||
          this.$route.name === "Process" ||
          this.$route.name === "Comparison" ||
          this.$route.name === "Simulation"
        )
          status = "done";
        if (index === this.steps.indexOf(this.$route.name.toLowerCase()))
          status = "active";
      }

      return status;
    }
  },
  created() {
  }
};
</script>

<style lang="scss" scoped>
#navigation {
  margin: 20px;
  margin-bottom: 0;
  position: relative;

  &.desktop {
    margin: 10px auto;
    margin-bottom: 0;
    width: 700px;
  }

  .step {
    z-index: 1;
    height: 30px;
    width: 30px;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 1.2rem;
    // border: 1px solid #fdcb47;
    color: $yellow;
    background: $white;
    cursor: default;


    &.done,
    &.active {
      cursor: pointer;
      background: $yellow;
      color: $black;
    }

    &.done + .separator {
      border: 1.5px solid $yellow;
    }

    &.TA {
      color: $black!important;

      &.done, &.active {
        background: $pink;
        color: $white!important;
      }
    }
  }

  .separator {
    position: absolute;
    z-index: 0;
    left: 30px;
    right: 30px;
    top: 12px;
    height: 6px;
    background: $white;

    span {
      display: block;
      height: 100%;
      width: 60%;
      background: $yellow;
    }

    &.TA {
      span {
        background-color: $pink;
      }
    }
  }

  // &.mobile {
  //   .step {
  //     height: 50px;
  //     width: 50px;
  //     font-size: 1.8rem;
  //   }

  //   .separator {
  //     width: 20px;
  //   }
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue